import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ChronoField, DateTimeFormatter, use} from 'js-joda';
import {ContactInfoService} from '../../Services/contact-info/contact-info.service';
import {AppointmentsService} from '../../Services/appointments/appointments.service';
import {CookieService} from 'angular2-cookie/services/cookies.service';
import {addStylesToBlock, scrollToElement} from '../../helpers';
declare var require: any;
use(require('js-joda-timezone'));

@Component({
  selector: 'app-review-info',
  templateUrl: './review-info.component.html',
  styleUrls: ['./review-info.component.scss']
})
export class ReviewInfoComponent implements OnInit {

  weekConvert = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday',
  };
  monthConvert = {
    1: 'January',
    2: 'Febuary',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  };

  DAY_OF_MONTH = ChronoField.DAY_OF_MONTH;
  DAY_OF_WEEK = ChronoField.DAY_OF_WEEK;
  MONTH_OF_YEAR = ChronoField.MONTH_OF_YEAR;
  HOUR_OF_DAY = ChronoField.HOUR_OF_DAY;
  YEAR = ChronoField.YEAR;

  ofPattern = DateTimeFormatter.ofPattern;

  contactInfo: ContactInfoService;
  appointmentsService: AppointmentsService;
  emptyContacts = false;
  isReschedule = '';
  userFirstName = '';
  userLastName = '';
  userPhone = '';
  userEmail = '';
  userCompany = '';
  userWebsite = '';
  formID = '';
  isAgencyTrue = false;
  monthly = 'no';
  aptMinutes = '60';

  constructor(contactInfo: ContactInfoService, appointmentsService: AppointmentsService) {
    this.contactInfo = contactInfo;
    this.appointmentsService = appointmentsService;
    this.isReschedule = CookieService.prototype.get('appointmentID');
    this.userFirstName = CookieService.prototype.get('firstName');
    this.userLastName = CookieService.prototype.get('lastName');
    this.userPhone = CookieService.prototype.get('phone');
    this.userEmail = CookieService.prototype.get('email');
    this.userCompany = CookieService.prototype.get('company');
    this.userWebsite = CookieService.prototype.get('website');
    if ( window['ngRoot'] !== null ) {
      this.formID = window['ngRoot'].getAttribute('data-formid');
      this.isAgencyTrue = Boolean(window['ngRoot'].getAttribute('data-agency'));
      this.monthly = window['ngRoot'].getAttribute('data-monthly') || 'no';
      this.aptMinutes = window['ngRoot'].getAttribute('data-minutes') || '60';
    }
  }

  @Output() close = new EventEmitter();

  @Input() dateTimeInfo;

  @Output() openEditInfo = new EventEmitter();

  @Output() openYoureAllSet = new EventEmitter();

  openEditInfoFunc($event) {
    this.openEditInfo.emit($event)
  }

  openYoureAllSetFunc($event) {
    console.log($event);
    this.openYoureAllSet.emit($event)
  }

  createAppointment(reschedule= '') {
    let error = false;
    const inps = document.getElementsByClassName('edit-info-inp');
    for ( let i = 0; i < inps.length; i++ ) {

      const inp = <HTMLInputElement>inps[i];

      if ( inp.value.length < 1 ) {
        inp.classList.add('err');
        error = true;
      } else {
        inp.classList.remove('err');
      }

      if ( inp.type === 'email' ) {
        const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        const emailDomain = inp.value.split('@')[1];
        if ( !regex.test( inp.value )
          || emailDomain === undefined
          || (this.contactInfo.freeEmailProviders !== [] && this.contactInfo.freeEmailProviders.includes(emailDomain)) ) {
          inp.classList.add('err');
          error = true;
        } else {
          inp.classList.remove('err');
        }
      }

      if ( inp.type === 'tel' ) {
        // let regex = /^(\d+-?|\d+\s?)+\d+$/;
        const regex1 = new RegExp(/(.)(\1){9,}/);
        const regex2 = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3,4}[-\s\.]?[0-9]{4,6}$/, 'i');
        if ( regex1.test( inp.value ) || !regex2.test( inp.value ) ) {
          inp.classList.add('err');
          error = true;
        } else {
          inp.classList.remove('err');
        }
      }

      if ( inp.name === 'website' ) {
        const regex = new RegExp(/^(((http|https):\/{2})?(([0-9a-z_-]+\.)+(aero|asia|biz|cat|com|company|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cx|cy|cz|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mn|mn|mo|mp|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|nom|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ra|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw|xyz|arpa)(:[0-9]+)?((\/([~0-9a-zA-Z\#\+\%@\.\/_-]+))?(\?[0-9a-zA-Z\+\%@\/&\[\];=_-]+)?)?))\b$/, 'i');
        if ( !regex.test( inp.value ) ) {
          inp.classList.add('err');
          error = true;
        } else {
          inp.classList.remove('err');
        }
      }
    }

    if ( !error ) {
      const contacts = this.contactInfo.getContactInfo();
      const date = this.dateTimeInfo.finalDate._dateTime.toString() + ':00' + window['appointmentTimezone'];

      addStylesToBlock('#starter-steps', 'display: none');
      addStylesToBlock('.activation-title', 'display: none');

      if ( reschedule === '' || reschedule === undefined ) {
        this.appointmentsService.createAppointment(date, contacts, true).subscribe((response) => {
          this.openYoureAllSet.emit();
          // document.getElementById('acuitycal-container').scrollIntoView();
          scrollToElement('#acuitycal-container', -140);
        });
      } else {
        this.appointmentsService.reschedule(date, true).subscribe((response) => {
          this.openYoureAllSet.emit();
          // document.getElementById('acuitycal-container').scrollIntoView();
          scrollToElement('#acuitycal-container', -140);
        });
      }
    } else {
      return false;
    }
  }

  onKeyUp(event: any) {
    if ( event.target.value.length < 1 ) {
      event.target.classList.add('err');
      event.target.parentElement.classList.remove('qerr2');
      event.target.parentElement.classList.add('qerr1');
    } else {
      event.target.classList.remove('err');
      event.target.parentElement.classList.remove('qerr1');
    }
  }

  onKeyUpPhone(event: any) {
    if ( event.target.value.length < 1 ) {
      event.target.classList.add('err');
      event.target.parentElement.classList.remove('qerr2');
      event.target.parentElement.classList.add('qerr1');
    } else {
      event.target.classList.remove('err');
      event.target.parentElement.classList.remove('qerr1');
      event.target.parentElement.classList.remove('qerr2');

      // let regex = /^(\d+-?|\d+\s?)+\d+$/;
      const regex1 = new RegExp(/(.)(\1){9,}/);
      const regex2 = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3,4}[-\s\.]?[0-9]{4,6}$/, 'i');
      if ( regex1.test( event.target.value ) || !regex2.test( event.target.value ) ) {
        event.target.classList.add('err');
        event.target.parentElement.classList.remove('qerr1');
        event.target.parentElement.classList.add('qerr2');
      } else {
        event.target.classList.remove('err');
        event.target.parentElement.classList.remove('qerr1');
        event.target.parentElement.classList.remove('qerr2');
      }
    }
  }

  onKeyUpEmail(event: any) {
    if ( event.target.value.length < 1 ) {
      event.target.classList.add('err');
      event.target.parentElement.classList.remove('qerr2');
      event.target.parentElement.classList.add('qerr1');
    } else {
      event.target.classList.remove('err');
      event.target.parentElement.classList.remove('qerr1');
      event.target.parentElement.classList.remove('qerr2');

      const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      const emailDomain = event.target.value.split('@')[1];
      if ( !regex.test( event.target.value ) || emailDomain === undefined || (this.contactInfo.freeEmailProviders !== [] && this.contactInfo.freeEmailProviders.includes(emailDomain)) ) {
        event.target.classList.add('err');
        event.target.parentElement.classList.remove('qerr1');
        event.target.parentElement.classList.add('qerr2');
      } else {
        event.target.classList.remove('err');
        event.target.parentElement.classList.remove('qerr1');
        event.target.parentElement.classList.remove('qerr2');
      }
    }
  }

  onKeyUpWebsite(event: any) {
    if ( event.target.value.length < 1 ) {
      event.target.classList.add('err');
      event.target.parentElement.classList.remove('qerr2');
      event.target.parentElement.classList.add('qerr1');
    } else {
      event.target.classList.remove('err');
      event.target.parentElement.classList.remove('qerr1');
      event.target.parentElement.classList.remove('qerr2');

      const regex = new RegExp(/^(((http|https):\/{2})?(([0-9a-z_-]+\.)+(aero|asia|biz|cat|com|company|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cx|cy|cz|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mn|mn|mo|mp|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|nom|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ra|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw|xyz|arpa)(:[0-9]+)?((\/([~0-9a-zA-Z\#\+\%@\.\/_-]+))?(\?[0-9a-zA-Z\+\%@\/&\[\];=_-]+)?)?))\b$/, 'i');
      if ( !regex.test( event.target.value ) ) {
        event.target.classList.add('err');
        event.target.parentElement.classList.remove('qerr1');
        event.target.parentElement.classList.add('qerr2');
      } else {
        event.target.classList.remove('err');
        event.target.parentElement.classList.remove('qerr1');
        event.target.parentElement.classList.remove('qerr2');
      }
    }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/Components/review-info/review-info.component.ts